import { ref } from "vue";

/**
 * 会員登録画面のUI状態を管理する composable。
 */
export const useMemberRegisterUiState = () => {
  const errdialog = ref(false); //エラーダイアログ
  const errMessage = ref(""); //エラーメッセージ
  const confirmPage = ref(false);
  const processFlag = ref(0);
  const addressDialog = ref(false);
  const areaDialog = ref(false);
  const uploadDialog = ref(false);
  const messagedialog = ref(false); //エラーダイアログ
  const message = ref(""); //エラーメッセージ
  const displayCompletedDialog = ref(false);

  //Loading
  const overlay = ref(false);

  return {
    errdialog,
    errMessage,
    confirmPage,
    processFlag,
    addressDialog,
    areaDialog,
    uploadDialog,
    messagedialog,
    message,
    displayCompletedDialog,
    overlay,
  };
};
